import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { screenReaderOnlyStaticStyle } from './styles';
function ScreenReaderOnly({ children }) {
    return _jsx("span", Object.assign({ css: screenReaderOnlyStaticStyle }, { children: children }));
}
export default ScreenReaderOnly;
